import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';
import { ErroNaTela } from './erro-na-tela.jsx';
import { instalarCapturaGlobal } from './registro-de-erros.js';
import './styles.css';
import './financeiro.css';

// Erro lançado dentro de um clique ou promessa sem `catch` nenhum componente pega: fica no console e na lista de suporte.
instalarCapturaGlobal();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErroNaTela nivel="app" chave="app">
      <App />
    </ErroNaTela>
  </React.StrictMode>
);
